import { Component, OnInit, ViewChild } from '@angular/core';
import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { CheckValidation } from 'src/app/shared/services/hr/CheckValidation.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'app-rewards',
  templateUrl: './rewards.component.html',
  styleUrls: ['./rewards.component.scss']
})
export class RewardsComponent implements OnInit {
  button = {}
  dataSource: any;
  TypeValue: any;
  TaxableStatus: {};
  InsuranceStatus: {}
  customDataSource: any;
  date = new Date()
  type: number;
  addpopup: string = '';
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang: any;
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  constructor(public gt: genericCustomStoreService, private validation: CheckValidation, public Objects: ObjectsService, public translate: TranslateService) {
    gt.seturl("Reward");
    gt.submit();
    this.customDataSource = gt.customDataSource;
    this.TypeValue = Objects.TypeValue;
    this.TaxableStatus = Objects.TaxableStatus;
    this.InsuranceStatus = Objects.InsuranceStatus
    this.button = Objects.button;
    this.validateAsync = this.validateAsync.bind(this);
    this.setCellValuetypevalue = this.setCellValuetypevalue.bind(this);
    this.validateAsyncForEn = this.validateAsyncForEn.bind(this)

    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );

    loadMessages({
      en: { "Yes": this.translate.instant('personal.yes'), "No": this.translate.instant('personal.no') }
    });

    // this.closeButtonOptions = {
    //   text: 'Close',
    //   onClick(){
    //     that.popupVisible = false;
    //   },
    // };
  }
  ngOnInit(): void { }
  validateAsync(params: any) {
    var id = params.data.id ?? 0;
    return this.validation.asyncCheckNameValue(params.value, id, "Reward");
  }
  validateAsyncForEn(params: any) {
    var id = params.data.id ?? 0;
    return this.validation.asyncCheckNameValue(params.value, id, "Reward", 'CheckName', 'NameEn');
  }
  updateRow(options: any) {
    options.newData = Object.assign(options.oldData, options.newData);
    options.newData.dateOfRegistration = this.date
  }
  onInitNewRow(e: any) {
    e.data.dateOfRegistration = this.date
    this.addpopup = this.translate.instant('tableinfo.addbutton')
  }
  onEditingStart() {
    this.addpopup = this.translate.instant('tableinfo.editbutton')

  }
  onEditorPreparing(e: any) {
    this.gt.onEditorPreparing(e)
  }
  addrowfun(name: string) {
    return this.gt.addrow(name)
  }

  setCellValuetypevalue(newData: any, value: any) {
    newData.valueType = value
    this.type = value
  }




}